import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { ShareSocialMediasDialogComponent } from "./share-social-medias-dialog.component";

@NgModule({
    declarations: [ShareSocialMediasDialogComponent],
    exports: [ShareSocialMediasDialogComponent],
    imports: [
        CommonModule,
        MatDialogModule,
        MatTooltipModule,
        FlexLayoutModule,
        FlexModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule
    ]
})
export class ShareSocialMediasDialogModule {}
